<template>
    <div class="container">
        <div class="agreement" v-html="agreementData"></div>
        <div class="footer">
            <van-button type="info" round color="#FFB14A" block @click="clickAgreement">我已阅读</van-button>
        </div>
    </div>
</template>
<script>
import { getActivityRuleContent } from "@/api/join";
export default {
    name:'buyerCancellationNotice',
    data(){
        return{
            agreementData:'',
        }
    },
    created(){
        this._getRuleContent()
    },
    methods:{
        async _getRuleContent(){
            const res = await getActivityRuleContent({type:34})
            if(res.appStatus.errorCode == 0){
                this.agreementData = res.content.content;
            }else{
                this.$toast(res.appStatus.message);
            }
        },
        clickAgreement(){
            this.$router.go(-1)
        },
    },
}
</script>
<style lang="scss" scoped>
    .container{
        // height: 100%;
        height: calc(100vh - 46px);
        padding: 0 10px;
        display: flex;
        flex-direction: column;
        .agreement{
            height: 100%;
            overflow-y: auto;
            flex: 1;
        }
        .footer{
            padding: 22px 0 20px 0;
            display: flex;
            flex-direction: column;
            align-items: center;
            /deep/.van-button{
                width: 345px;;
            }
        }
    }
</style>